<template>
  <div id="activityPage">
    <Background-Image color="#F8F6EE" opacity="1" v-if="activityStatus !== 404"></Background-Image>
    <Background-Image url="albufeira.jpg" color="#F8F6EE" v-if="activityStatus == 404"></Background-Image>
    <Navigation page="activity" :showUserNav="true"></Navigation>
    <div class="calendarOnTop" v-if="showCalendarOnTop">
      <ActivityCalendar class="activityCalendar" :activityId="activity.id" :showCloseButton="true"></ActivityCalendar>
    </div>
    <div class="container-fluid m-t-6" id="status404" v-if="activityStatus == 404">
      <div class="row">
        <div class="NotFoundCard col-md-6 col-md-offset-3">
          <!--Card-->
          <div class="card">
            <!--Card content-->
            <div class="card-block">
              <!--Title-->
              <h4 class="card-title">{{t('Activity not found')}}</h4>
              <!--Text-->
              <p class="card-text">{{t('Sorry, the activity you were looking for was not found.')}}</p>
              <router-link :to="'/' + language" class="btn btn-primary">{{t('Return to the Homepage')}}</router-link>
            </div>
            <!--/.Card content-->
          </div>
          <!--/.Card-->
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="activity.translations && activityStatus == 200">
      <div v-if="!activity.approved" class="row m-t-4">
        <div class="col-xs-12 text-xs-center">
          <Card>
          <div slot="title">{{t('Preview')}}</div>
          <div slot="content">{{t('This activity is not yet publicly visible because is waiting for administrator approval')}}</div>
          </Card>
        </div>
      </div>
      <div v-if="activity.translations[language]">
        <div class="row">
          <div class="col-md-8 col-sm-12 m-t-4">
            <ActivityImages></ActivityImages>
          </div>
          <div class="m-t-4 calendarSide col-md-4">
            <ActivityCalendar :activityId="activity.id"></ActivityCalendar>

            <div class="card contactUsCard">
              <!--Card content-->
              <div class="card-block">
                <!--Title-->
                <h4 class="card-title">{{t('Need help?')}}</h4>
                <!--Text-->
                <p class="card-text">
                {{t('If you would like some help or advice for your next tour, feel free to contact us.')}}
                <div class="phoneBlock"><i class="icon fa fa-phone"></i> <span class="phone">+351 000 000 000</span></div>
                <div class="emailBlock"><i class="icon fa fa-envelope"></i> <span class="email">mail@example.com</span></div>
              </div>
              <!--/.Card content-->
            </div>
          </div>
          <div class="col-md-8 m-t-2">
            <div id="activityDescription">
              <!--Card-->
              <div class="card" v-if="activity.translations[language]">
                <div class="card-block">
                  <ActivityDescription></ActivityDescription>
                  <ActivityExtraInfo></ActivityExtraInfo>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row m-t-2">
          <div class="col-md-8">
            <ActivityMap></ActivityMap>
          </div>
        </div>
        <!--div class="row m-t-3">
          <div class="col-md-8">
          <ActivityExtraInfo></ActivityExtraInfo>
          </div>
          </div-->
      </div>
      <div v-else>
        <div class="row">
          <div class="col-md-6">
            <ActivityWithoutTranslation></ActivityWithoutTranslation>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MatchHeight from 'jquery-match-height'; // eslint-disable-line
import Navigation from '../Navigation/Navigation';
import ActivityImages from './ActivityImages';
import ActivityDescription from './ActivityDescription';
import ActivityMap from './ActivityMap';
import ActivityWithoutTranslation from './ActivityWithoutTranslation';
import ActivityExtraInfo from './ActivityExtraInfo';
import ActivityCalendar from './ActivityCalendar';
import ActivityReviews from './ActivityReviews';
import BackgroundImage from '../BackgroundImage';
import Card from '../Card';

const $ = window.$;

export default {
  name: 'Activity',
  components: {
    Navigation,
    'Background-Image': BackgroundImage,
    Card,
    ActivityImages,
    ActivityDescription,
    ActivityMap,
    ActivityExtraInfo,
    ActivityCalendar,
    ActivityWithoutTranslation,
    'Activity-Reviews': ActivityReviews,
  },
  computed: {
    ...mapState({
      activityStatus: state => state.activityPublic.statusCode,
      activity: state => state.activityPublic.activity,
      language: state => state.language,
      showCalendarOnTop: state => state.activityUI.showCalendarOnTop,
    }),
  },
  methods: {
    ...mapActions({
      setLastActivityUrl: 'setLastActivityUrl',
    }),
    scrollToReviews() {
      $('html, body').animate({
        scrollTop: window.jQuery('#reviews').offset().top,
      }, 800);
    },
    setCalendarPosition() {
      const windowHeight = window.innerHeight;
      const calendarSideEl = document.querySelector('.calendarSide');
      let calendarSideHeight = 0;
      if (calendarSideEl !== null) {
        calendarSideHeight = calendarSideEl.offsetHeight;
        const calendarSideOffset = calendarSideEl.offsetTop;
        const calendarSideFromTopTotal = calendarSideOffset + calendarSideHeight;
        if (calendarSideFromTopTotal < windowHeight) {
          calendarSideEl.classList.add('calendarFixed');
          calendarSideEl.classList.remove('col-md-4');
        } else {
          calendarSideEl.classList.remove('calendarFixed');
          calendarSideEl.classList.add('col-md-4');
        }
      }
      // And the same for top calendar
      const calendarTopEl = document.querySelector('.calendarOnTop');
      let calendarTopHeight = 0;
      if (calendarTopEl !== null) {
        calendarTopHeight = calendarTopEl.offsetHeight;
        const calendarTopOffset = calendarTopEl.offsetTop;
        const calendarTopFromTopTotal = calendarTopOffset + calendarTopHeight;
        if (calendarTopFromTopTotal < windowHeight) {
          calendarTopEl.classList.add('calendarFixed');
          calendarTopEl.classList.remove('col-md-4');
        } else {
          calendarTopEl.classList.remove('calendarFixed');
          calendarTopEl.classList.add('col-md-4');
        }
      }
    },
  },
  created() {
    /* if (typeof window.Tawk_API !== 'undefined') {
        window.Tawk_API.hideWidget();
      } */
    if (typeof this.$route.params.slug !== 'undefined') {
      this.$store.dispatch('getActivityPublic', { slug: this.$route.params.slug });
    }
  },
  mounted() {
    setTimeout(() => {
      $('.sameHeight').matchHeight();
    }, 0);
    // window.addEventListener('resize', this.setCalendarPosition);
    // this.setCalendarPosition();
    this.setLastActivityUrl(window.location.href);
  },
  beforeDestroy() {
    /* window.removeEventListener('resize', this.setCalendarPosition);
      if (typeof window.Tawk_API !== 'undefined') {
        window.Tawk_API.showWidget();
      } */
  },
  watch: {
    activity() {
      // this.setCalendarPosition();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4"; /* for $brand-primary */
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";

/* 1.  ALL SCREENS*/
#activityPage {
  min-height: 100vh;
  padding-bottom: 100px;
}
.NotFoundCard {
  margin-top: 100px;
}

.images {
  margin-top: 35px;
}

.calendarSide {
  display: none;
}
.calendarOnTop {
  position: absolute;
  padding-top: 100px;
  padding-left: 30px;
  padding-right: 30px;
  width: 100%;
  z-index:2000000001;
}
.calendarOnTop::before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  background-color: rgba(0,0,0, 0.5);
}

.calendarFixed {
  position: fixed;
}

.calendarOnTop.calendarFixed {
  top: 0;
}

.calendarSide.calendarFixed {
  top: calc(6rem);
  width: calc(33.333333% );
  right: -6%;
}
.contactUsCard {
  margin-top: 30px;
  .fa {
    color: #00B48D;
    display: inline-block;
    min-width: 20px;
  }
}

/* Small Screen 544px */
@media only screen and (min-width: map-get($grid-breakpoints, sm)) {

}

/* Small Devices, Tablets 768px */
@media only screen and (min-width: map-get($grid-breakpoints, md)) {
  .calendarOnTop {
    display: none;
  }
  .calendarSide.calendarFixed {
    right: 3%;
    width: 30%
  }
  .calendarSide {
    display: block;
    float: right;
  }
}

/* Medium Devices, Desktops */
@media only screen and (min-width: map-get($grid-breakpoints, lg)) {

  .calendarSide.calendarFixed {
    top: calc(6rem);
    width: calc(33.333333% - 6%);
    right: 6%;
  }
}

/* Large Devices, Wide Screens  1200px */
@media only screen and (min-width: map-get($grid-breakpoints, xl)) {

}

/*
.imageAndTitle {
position: relative;
}

.activityHeader {
background: linear-gradient(to bottom, rgba(darken($primary-color, 30%), 0.5) 0%, rgba($primary-color, 0) 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 );
color: white;
position: absolute;
left: 15px;
right: 15px;
top: 0;
z-index: 2;
padding-left: 30px;
padding-bottom: 200px;
padding-top: 15px;
.stars {
  position: absolute;
  right: 30px;
  top: 20px;
  color: saturate(lighten(#FFBB33, 5%),100%);
  cursor: pointer;
}
     }
     .pricesFrom {
       position: absolute;
       bottom: 45px;
       right: 10px;;
       z-index: 2;
       color: white;
       background-color: $brand-primary;
       padding: 6px 15px;
       font-weight: 700;
     }
 */
</style>



// WEBPACK FOOTER //
// Activity.vue?448dc5f3